import { render, staticRenderFns } from "./PatientDetailPage.vue?vue&type=template&id=25e3d59e"
import script from "./PatientDetailPage.vue?vue&type=script&lang=js"
export * from "./PatientDetailPage.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailPage.vue?vue&type=style&index=0&id=25e3d59e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports